import { Component, createRef } from 'react';
import { Tabs as BootstrapTabs, Tab } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import autoBind from 'react-autobind';
import loadable from '@utils/loadable';
import { withRouter } from 'react-router-dom';

import Alert from '../Shared/ReactAlert';

import * as storyFiltersActions from '../../actions/storyFilters.action';
import * as watchlistActions from '../../actions/watchlistActions';

import PiwikContext from '../../services/piwikContext';

import withComponentName from '../../decorators/withComponentName';

import TrendingTopics from './TrendingTopics';
import { clearSavedTrendingFiltersStates } from '../../services/localStorage';

import './styles.css';
import { orderValuesTab, sentimentValuesTab } from '../../data/filters/storyFilters';
import StorageSvc from '../../services/StorageSvc';
import ScrollableTabs from '../Shared/ScrollableTabs';

const TrendingHead = loadable(() => import('./TrendingHead'));
const TrendingFilters = loadable(() => import('./TrendingFilters'));
const TrendingPersonalisationFilter = loadable(() => import('./TrendingFilters/TrendingPersonalisationFilter'));
const TrendingStories = loadable(() => import('../TrendingStories'));

export class MainTrending extends Component {
  constructor(props) {
    super(props);
    this.state = {
      trendingExpand: false,
      personalisationExpand: false,
      width: 0,
      isAdvancedView: false,
      activeOrderTab: 'top',
      activeSentimentTab: 'all',
    };
    autoBind(this);
    this.tabsBar = createRef();
    try {
      this.userSimplifiedView = JSON.parse(StorageSvc.getItem('userSimplifiedView'));
    } catch (e) {
      this.userSimplifiedView = false;
    }
  }

  componentDidMount() {
    const {
      actions, token, history,
    } = this.props;
    const { width } = this.state;

    this.setState({
      trendingExpand: !(width < 481),
      width: window.innerWidth,
    });
    this.fetchSelectedTabs();
    const sentimentName = history.location.pathname.split('/').reverse()[0];
    this.setState({
      isAdvancedView: ((['all', 'very_positive', 'positive', 'neutral', 'negative', 'very_negative'].includes(sentimentName)) || this.userSimplifiedView),
    }, () => {
      const { isAdvancedView, activeSentimentTab } = this.state;
      StorageSvc.setItem(
        'selectedSentimentTab',
        JSON.stringify({ activeSentimentTab }),
      );
      actions.setSentimentTab(activeSentimentTab);
      if (isAdvancedView) {
        history.push(`/news/${activeSentimentTab}`);
      } else if (!isAdvancedView) {
        history.push('/news');
      }
    });

    actions.setUserToken(token);
  }

  componentDidUpdate(prevProps) {
    const { orderTab } = this.props;
    if (prevProps.orderTab && (orderTab !== prevProps.orderTab)) {
      this.setState({
        activeOrderTab: orderTab,
      }, () => {
        const { activeOrderTab } = this.state;
        this.handleOrderTabClick(activeOrderTab);
      });
    }
  }

  handleOrderTabClick(activeOrderTab) {
    const { actions, token, piwikEnabled } = this.props;
    StorageSvc.setItem(
      'selectedOrderTab',
      JSON.stringify({ activeOrderTab }),
    );
    if (piwikEnabled) _paq.push(['trackEvent', 'Filters', 'Story order', activeOrderTab]);
    this.setState({
      activeOrderTab,
    }, () => {
      const { activeOrderTab } = this.state;
      actions.filterByStoryOrder(activeOrderTab, token);
    });
  }

  handleSentimentTabClick(activeSentimentTab) {
    const { actions, history } = this.props;
    actions.setSentimentTab(activeSentimentTab);
    StorageSvc.setItem(
      'selectedSentimentTab',
      JSON.stringify({ activeSentimentTab }),
    );
    this.setState({
      activeSentimentTab,
    }, () => {
      const { activeSentimentTab } = this.state;
      if (activeSentimentTab) {
        history.push(`/news/${activeSentimentTab}`);
      }
    });
  }

  handleSimplifiedViewTabsClick(show) {
    this.fetchSelectedTabs();
    const { actions, history, token } = this.props;
    this.setState({
      isAdvancedView: show,
    }, () => {
      const { isAdvancedView, activeSentimentTab, activeOrderTab } = this.state;
      if (isAdvancedView) {
        history.push(`/news/${activeSentimentTab}`);
        actions.filterByStoryOrder(activeOrderTab, token);
        StorageSvc.setItem(
          'selectedOrderTab',
          JSON.stringify({ activeOrderTab }),
        );
      } else {
        history.push('/news');
      }
    });
  }

  getTrendingTopics(topics) {
    this.setState({ trendingTopics: topics });
  }

  resetTrendingFilters() {
    const { actions } = this.props;

    this.setState({
      trendingExpand: false,
    }, () => {
      clearSavedTrendingFiltersStates();
      actions.resetTrendingFilters();
    });
  }

  toggleExpand(type, value) {
    this.setState({
      [type]: value,
    });
  }

  fetchSelectedTabs() {
    const { history, actions, token } = this.props;
    const getSelectedOrderTab = JSON.parse(StorageSvc.getItem('selectedOrderTab'));
    const getSelectedSentimentTab = JSON.parse(StorageSvc.getItem('selectedSentimentTab'));
    const sentimentName = history.location.pathname.split('/').reverse()[0];

    if (getSelectedOrderTab?.activeOrderTab) {
      this.setState({
        activeOrderTab: getSelectedOrderTab?.activeOrderTab || 'top',
      }, () => {
        const { activeOrderTab } = this.state;
        if (activeOrderTab !== 'latest') {
          actions.filterByStoryOrder(activeOrderTab, token);
        }
      });
    }
    if (['all', 'very_positive', 'positive', 'neutral', 'negative', 'very_negative'].includes(sentimentName)) {
      this.setState({
        activeSentimentTab: sentimentName,
      }, () => {
        const { activeSentimentTab } = this.state;
        StorageSvc.setItem(
          'selectedSentimentTab',
          JSON.stringify({ activeSentimentTab }),
        );
      });
    } else if (getSelectedSentimentTab?.activeSentimentTab) {
      this.setState({
        activeSentimentTab: getSelectedSentimentTab?.activeSentimentTab || 'all',
      });
    }
  }

  render() {
    const {
      searchBarActive,
      blurSearchbar,
      user,
      refresh_rate: refreshEvery,
      hideRightSide,
    } = this.props;
    const {
      trendingExpand,
      personalisationExpand,
      trendingTopics,
      width,
      isAdvancedView,
      activeOrderTab,
      activeSentimentTab,
    } = this.state;

    return (
      <div className={blurSearchbar && searchBarActive ? 'trending_blured' : ''}>
        <div className="Trending">
          <div className="Trending__container">
            <div className="Trending__container--content">
              <TrendingHead
                trendingExpand={trendingExpand}
                personalisationExpand={personalisationExpand}
                onExpandChange={this.toggleExpand}
              />
              <div className={`Filters__container ${trendingExpand || personalisationExpand ? 'expanded' : ''}`}>
                {trendingExpand ? (
                  <PiwikContext.Consumer>
                    {(value) => (
                      <TrendingFilters
                        ref={(el) => { this.trendingFilters = el; }}
                        piwikEnabled={value.piwikEnabled}
                        width={width}
                      />
                    )}
                  </PiwikContext.Consumer>
                ) : (
                  personalisationExpand && <TrendingPersonalisationFilter user={user} />
                )}
              </div>
              <div className={`simplifiedview__Tabs ${isAdvancedView ? 'show' : ''}`}>
                <ScrollableTabs
                  tabs={orderValuesTab}
                  activeTab={activeOrderTab}
                  onTabClick={this.handleOrderTabClick}
                  ref={this.tabsBar}
                  classname="subTab_news"
                />
                <ScrollableTabs
                  tabs={sentimentValuesTab}
                  activeTab={activeSentimentTab}
                  onTabClick={this.handleSentimentTabClick}
                  ref={this.tabsBar}
                  classname="subTab_news"
                />
              </div>
              <BootstrapTabs defaultActiveKey={1} id="Trending__maintabs">
                <Tab
                  eventKey={1}
                  title="Stories"
                  className={`${hideRightSide ? ' full-width' : ''}`}
                >
                  <PiwikContext.Consumer>
                    {(value) => (
                      <TrendingStories
                        user={user}
                        resetTrendingFilters={this.resetTrendingFilters}
                        trendingTopics={trendingTopics}
                        piwikEnabled={value.piwikEnabled}
                        onSimplifiedViewTabsClick={this.handleSimplifiedViewTabsClick}
                        isAdvancedLayout={isAdvancedView}
                        activeSentimentTab={activeSentimentTab}
                        isTrendingPage
                      />
                    )}
                  </PiwikContext.Consumer>
                </Tab>
                {!hideRightSide ? (
                  <Tab eventKey={2} title=" Trending Topics">
                    <PiwikContext.Consumer>
                      {(value) => (
                        <TrendingTopics
                          user={user}
                          refresh_rate={refreshEvery}
                          getTrendingTopics={this.getTrendingTopics}
                          piwikEnabled={value.piwikEnabled}
                        />
                      )}
                    </PiwikContext.Consumer>
                  </Tab>
                ) : null}
              </BootstrapTabs>
            </div>
          </div>
          <Alert stack={false} timeout={3000} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  stories: state.stories.cards,
  searchBarActive: state.searchReducers.searchBarActive,
  blurSearchbar: state.searchReducers.blur,
  refresh_rate: state.storyFilters.refresh_rate,
  token: state.watchlistReducer.userToken,
  selectedOrderTab: state.storyFilters.selected_order_tab,
  selectedSentimentTab: state.storyFilters.selected_sentiment_tab,
  orderTab: state.storyFilters.order_by,
  hideRightSide: state.chatbot.isChatbotOpened && (state.common.width > 1024 && state.common.width < 1500),
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ ...storyFiltersActions, ...watchlistActions }, dispatch),
});

export default withRouter(
  withComponentName(
    connect(mapStateToProps, mapDispatchToProps)(MainTrending),
  ),
);
